import React from "react";
import { useDispatch } from "react-redux";
import Canvas from "../../../components/Canvas";
import { setModalLoading } from "../../../actions/loading";

const HeroSection = () => {
  const dispatch = useDispatch();

  const handleBookInterview = () => {
    dispatch(setModalLoading(true));
  };

  return (
    <section className="hero-section">
      <Canvas />
      <div className="container hero-grid">
        <div>
          <p className="eyebrow">Career management for modern professionals</p>
          <h1>Stop Applying. Start Getting Interviews.</h1>
          <p className="hero-copy">
            Lovapex Tech combines career managers, recruiter outreach, ATS-ready
            resumes, and job search tracking into one focused hiring engine.
          </p>
          <div className="actions">
            <button
              className="button button-primary button-md"
              onClick={() => handleBookInterview()}
            >
              Book a Free Strategic Consultation
            </button>
            <a
              className="button button-secondary button-md"
              href="/careers"
              data-discover="true"
            >
              View Open Roles
            </a>
          </div>
          <div className="hero-proof-grid">
            <div>
              <strong>200+</strong>
              <span>targeted applications</span>
            </div>
            <div>
              <strong>1:1</strong>
              <span>career manager support</span>
            </div>
            <div>
              <strong>Weekly</strong>
              <span>progress updates</span>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="visual-panel">
            <span>CareerOS</span>
            <strong>156 active applications</strong>
            <p>
              Interviews, follow-ups, recruiter notes, and next actions in one
              command center.
            </p>
            <div className="pipeline-list">
              <div>
                <span>New</span>
                <strong>42</strong>
              </div>
              <div>
                <span>Interviewing</span>
                <strong>18</strong>
              </div>
              <div>
                <span>Follow-ups</span>
                <strong>63</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
